// @ts-ignore
import { createBrowserHistory } from 'history';
// @ts-ignore
export const history = createBrowserHistory();
